import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=23128125&scoped=true"
import script from "./MyMessage.vue?vue&type=script&lang=js"
export * from "./MyMessage.vue?vue&type=script&lang=js"
import style0 from "./MyMessage.vue?vue&type=style&index=0&id=23128125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23128125",
  null
  
)

export default component.exports